<template>
  <div id="suppliers-table">
    <span class="table-name">{{ $t("suppliers_table.suppliers") }}</span>
    <span class="create-button">
      <button type="button" class="btn btn-primary" @click="openSuppliersMaker">
        {{ $t("suppliers_table.new_supplier") }}
      </button>
    </span>
    <div class="table-wrapper">
      <div class="progress-wrapper">
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
      </div>
      <div class="rTable">
        <div class="rTableRow problem-header">
          <div
            class="rTableHead"
            v-for="(header, i) in headers"
            :key="i"
            :style="{ width: header.width + '%' }"
          >
            <span>{{ header.text }}</span>
          </div>
        </div>
        <div class="rTableRow" v-for="(supplier, i) in suppliers" :key="i">
          <div class="rTableCell">
            <span v-if="supplier.order_number != null">*</span
            >{{ supplier.title }}
          </div>
          <div class="rTableCell">
            {{ supplier.short_title }}
          </div>
          <div class="rTableCell">
            <v-icon
              v-if="supplier.order_number != null"
              class="mr-2"
              small
              v-tooltip="$t('suppliers_table.dont_show')"
              @click="removeSupplier(supplier)"
              >remove</v-icon
            >
            <v-icon
              v-else
              class="mr-2"
              small
              @click="addSupplier(supplier)"
              v-tooltip="$t('suppliers_table.show')"
              >add</v-icon
            >
            <v-icon
              v-if="supplier.order_number != null"
              class="mr-2"
              small
              @click="orderUp(supplier, i)"
              >arrow_upward</v-icon
            >
            <v-icon
              v-if="supplier.order_number != null"
              class="mr-2"
              small
              @click="orderDown(supplier, i)"
              >arrow_downward</v-icon
            >
            <v-icon
              v-if="supplier.company_id != null"
              class="mr-2"
              v-tooltip="$t('suppliers_table.delete')"
              small
              @click="deleteSupplier(supplier)"
              >delete</v-icon
            >
          </div>
        </div>
      </div>
    </div>
    <div class="text-xs-center">
      <v-pagination
        v-model="page"
        :length="pages"
        @input="changePage"
      ></v-pagination>
    </div>
    <SupplierDialog ref="supplierDialog" @updated="initialize"></SupplierDialog>
  </div>
</template>

<script>
import Helper from "@/models/Helper.js";
import Supplier from "@/models/Supplier.js";
import SupplierDialog from "@/components/production-planning/SupplierDialog.vue";
export default {
  name: "suppliers-table",
  components: {
    SupplierDialog,
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: this.$t("suppliers_table.title"),
          width: 45,
        },
        {
          text: this.$t("suppliers_table.short_title"),
          width: 45,
        },
        {
          text: this.$t("suppliers_table.actions"),
          width: 10,
        },
      ],
      suppliers: [],
      page: 1,
      pages: 1,
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading = true;
      const allSuppliers = await Supplier.loadSuppliers(this.page);
      const showingSuppliers = await Supplier.loadShowing();
      this.suppliers = this.sortSuppliers(allSuppliers, showingSuppliers);
      this.loading = false;
    },
    sortSuppliers(allSuppliers, showingSuppliers) {
      //show showing suppliers first (sort by ascending order_number)
      showingSuppliers.sort((a, b) => {
        return a.order_number - b.order_number;
      });
      //push remaining suppliers to showing suppliers
      for (const supplier of allSuppliers) {
        const found = showingSuppliers.find((showingSupplier) => {
          return supplier.id === showingSupplier.id;
        });
        //if not already showing, push to end
        if (!found) {
          showingSuppliers.push(supplier);
        }
      }
      return showingSuppliers;
    },
    orderUp(supplier, i) {
      const higherSupplier = this.suppliers[i - 1];
      if (!higherSupplier) return;
      this.suppliers = Helper.swapArrayElements(this.suppliers, i, i - 1);
      this.updateSuppliers();
    },
    orderDown(supplier, i) {
      const lowerSupplier = this.suppliers[i + 1];
      if (!lowerSupplier) return;
      if (lowerSupplier.order_number == null) return;
      this.suppliers = Helper.swapArrayElements(this.suppliers, i, i + 1);
      this.updateSuppliers();
    },
    addSupplier(supplier) {
      supplier.order_number = 0;
      this.updateSuppliers();
    },
    removeSupplier(supplier) {
      supplier.order_number = null;
      this.updateSuppliers();
    },
    async updateSuppliers() {
      const showingSuppliers = this.suppliers.filter((supplier) => {
        return supplier.order_number != null;
      });
      const suppliers = [];
      let count = 0;
      for (const supplier of showingSuppliers) {
        suppliers.push({
          supplier_id: supplier.id,
          order_number: count * 1,
        });
        count += 1;
      }
      await Supplier.createShowingSuppliers({ suppliers: suppliers });
      this.initialize();
    },
    async deleteSupplier(supplier) {
      const confimation = confirm(this.$t('suppliers_table.delete_confirm'));
      if(!confimation) return;
      await supplier.remove();
      this.initialize();
    },
    changePage() {
      this.initialize();
    },
    openSuppliersMaker() {
      this.$refs.supplierDialog.openCreate();
    },
  },
};
</script>

<style scoped>
.create-button {
  float: right;
  margin-right: 20px;
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>